
import { Component, Vue, Prop } from "vue-property-decorator";
import DateTimeMixin from "@/mixins/datetime";
import { i18n } from "@/i18n";
import { Transaction } from "@/entities";
import { PCol, PFormSelectNarrow, PRow } from "@/common/components";
import LogicCashTodayDetailLastTransactions from "@/pages/logic-cash-today-detail/components/LogicCashTodayDetailLastTransactions.vue";

@Component({
  mixins: [DateTimeMixin],
  components: {
    LogicCashTodayDetailLastTransactions,
    PRow,
    PCol,
    PFormSelectNarrow,
  },
})
export class DetailTransaction extends Vue {
  @Prop({ required: true }) value!: boolean;
  @Prop({ required: true, default: {} }) transaction!: Transaction;

  language = i18n.locale;
  options = [
    { text: this.$t("transactions.filter.showAllFields"), value: "showAllFields" },
    { text: this.$t("transactions.filter.dontShowAllFields"), value: "dontShowAllFields" },
  ];
  valueSelect = "";

  destroyed(): void {
    this.$emit("input", !this.value);
  }

  get origin(): string {
    return this.formatOrigin(this.transaction?.origin || "");
  }

  formatOrigin(origin: string): string {
    const key = `transactions.transactionOrigin.${origin}`;
    const translated = this.$t(key).toString();
    return translated === key ? origin : translated;
  }

  get denominations() {
    return this.transaction?.denominations || [];
  }

  getCategoryStatusLabel(status: string): string {
    const key = `transactions.denominationStatus.${status}`;
    const translated = this.$t(key).toString();
    return translated === key ? status : translated;
  }
}
export default DetailTransaction;
